/* eslint-disable */
import React from 'react';
import { ImageSelect } from '../_shared/ImageSelect';

const OPTIONS = [{ id: 'straight' }, { id: 'wavy' }, { id: 'curly' }, { id: 'coily' }, { id: 'locs' }, { id: 'braided' }, { id: 'shotCoils' }, { id: 'other' }];

function Page() {
  return (
    <ImageSelect
      page="hairstyle-hair-texture"
      progress={36}
      field="hairstyleHairTexture"
      setter="setHairstyleHairTexture"
      ns="hairstyleHairTexture"
      options={OPTIONS}
    />
  );
}

export default Page;
